var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1898 18.9813L11.5 26.671L3.81021 18.9813C-0.436738 14.7343 -0.436738 7.84867 3.81021 3.60172C8.05717 -0.645234 14.9428 -0.645234 19.1898 3.60172C23.4368 7.84867 23.4368 14.7343 19.1898 18.9813ZM11.5 13.7082C12.8347 13.7082 13.9167 12.6262 13.9167 11.2915C13.9167 9.95682 12.8347 8.87484 11.5 8.87484C10.1653 8.87484 9.08333 9.95682 9.08333 11.2915C9.08333 12.6262 10.1653 13.7082 11.5 13.7082Z",
    fill: "#ED1002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.a84aae21106910efd23e6edc42067ae7.svg";
export { ForwardRef as ReactComponent };